var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Retriever } from "../../../../../common";
export class TodayLiveStreamingRetriever extends Retriever {
    constructor(baseRetriever, timeZoneObservable, clock, queryFactory) {
        super();
        this.baseRetriever = baseRetriever;
        this.timeZoneObservable = timeZoneObservable;
        this.clock = clock;
        this.queryFactory = queryFactory;
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.baseRetriever.activate();
            yield this.timeZoneObservable.observe((timezone) => {
                const requestProvider = () => this.getRequest(timezone);
                return this.baseRetriever.refresh(state, requestProvider);
            });
        });
    }
    getRequest(timeZone) {
        const from = this.clock.getBeginningOfTodayForTimeZone(timeZone);
        return this.queryFactory(from);
    }
    deactivate() {
        this.baseRetriever.deactivate();
    }
}
//# sourceMappingURL=TodayLiveStreamingRetriever.js.map